import { takeLatest } from 'redux-saga/effects';
import {
    CLEAR_LOGIN_STATE,
    LOGIN_REQUEST,
    LOGIN_SILENT_REQUEST,
    VALIDATE_SESSION_REQUEST,
    CLEAR_CACHE_LOGIN_STATE,
    VALIDATE_USERNAME_AND_PASS_REQUEST,
    VALIDATE_USERNAME_AND_PASS_SILENT_REQUEST,
} from '../../redux/modules/login/login-actions';
import {
    login, loginSilently, logout, validateSessionWorker,
    clearCacheAndLogout,
    validateUsernameAndPass,
    validateUsernameAndPassSilent,
} from './loginWorkerSaga';


export function* loginSaga() {
    yield takeLatest(LOGIN_REQUEST, login);
}

export function* validateUsernameAndPassWatcherSaga() {
    yield takeLatest(VALIDATE_USERNAME_AND_PASS_REQUEST, validateUsernameAndPass);
}

export function* validateUsernameAndPassSilentWatcherSaga() {
    yield takeLatest(VALIDATE_USERNAME_AND_PASS_SILENT_REQUEST, validateUsernameAndPassSilent);
}

export function* logoutSaga() {
    yield takeLatest(CLEAR_LOGIN_STATE, logout);
}

export function* validateSessionSaga() {
    yield takeLatest(VALIDATE_SESSION_REQUEST, validateSessionWorker);
}

export function* loginSilentSaga() {
    yield takeLatest(LOGIN_SILENT_REQUEST, loginSilently);
}

export function* clearCacheAndLogoutSaga() {
    yield takeLatest(CLEAR_CACHE_LOGIN_STATE, clearCacheAndLogout);
}
